import React from 'react';
import ChevronDown from '@uber/base-icons/chevron-down';
import { useStyletron } from 'baseui';
import { Input, SIZE as INPUT_SIZE } from 'baseui/input';
import { LabelXSmall } from 'baseui/typography';
import { useDOMWidth } from '../hooks/use-dom-width';
import type { FrameTimeInputProps } from './types';
import { getInputWidthFromMeasure, getMeasureReferenceText } from './utils';
export const FrameTimeInput = ({
  value,
  total,
  label,
  toggleLabel,
  onValueChange,
  onToggle,
  onBlur,
  error = false,
  placeholder
}: FrameTimeInputProps) => {
  const [css, theme] = useStyletron();
  const {
    width: measureWidth,
    measureRef
  } = useDOMWidth();
  const referenceText = getMeasureReferenceText(value, total);
  const inputWidth = getInputWidthFromMeasure(measureWidth, theme.sizing.scale300);
  const secondaryText = {
    ...theme.typography.LabelSmall,
    color: theme.colors.contentTertiary
  };
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale300
  })}>
      <span ref={measureRef} data-testid="input-hidden-measure" className={css({
      ...theme.typography.LabelSmall,
      position: 'absolute',
      visibility: 'hidden',
      whiteSpace: 'pre',
      padding: '0',
      margin: '0',
      height: '0',
      overflow: 'hidden'
    })}>
        {referenceText}
      </span>
      <LabelXSmall>{label}</LabelXSmall>
      <Input value={value} onChange={e => onValueChange(e.currentTarget.value)} onBlur={onBlur} placeholder={placeholder} size={INPUT_SIZE.mini} error={error} overrides={{
      Root: {
        style: ({
          $theme
        }) => ({
          width: inputWidth,
          minWidth: $theme.sizing.scale1000,
          height: $theme.sizing.scale900,
          backgroundColor: $theme.colors.backgroundSecondary,
          borderRadius: $theme.borders.radius300,
          borderWidth: '0px',
          display: 'flex',
          alignItems: 'center'
        })
      },
      Input: {
        style: ({
          $theme
        }) => ({
          ...$theme.typography.LabelSmall,
          color: $theme.colors.contentTertiary,
          textAlign: 'right',
          paddingTop: '0px',
          paddingBottom: '0px',
          paddingLeft: $theme.sizing.scale300,
          paddingRight: $theme.sizing.scale300
        })
      }
    }} />
      <span className={css(secondaryText)}>/</span>
      <span className={css(secondaryText)}>{total}</span>
      <button type="button" onClick={onToggle} className={css({
      ...secondaryText,
      backgroundColor: theme.colors.backgroundSecondary,
      borderRadius: theme.borders.radius300,
      border: 'none',
      height: theme.sizing.scale900,
      padding: `0px ${theme.sizing.scale300}`,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.sizing.scale200,
      ':hover': {
        backgroundColor: theme.colors.backgroundTertiary
      }
    })}>
        {toggleLabel}
        <ChevronDown size={12} />
      </button>
    </div>;
};